import axios from '@axios';

const baseUrl = 'api/v1/social-visits/locations';

export default {
  getVisitLocationsForPrison() {
    return axios.get(`${baseUrl}`);
  },
  createVisitLocation(createDto) {
    return axios.post(`${baseUrl}/create`, createDto);
  },
  updateVisitLocation(id, updateDto) {
    return axios.put(`${baseUrl}/update/${id}`, updateDto);
  },
  deleteVisitLocation(id) {
    return axios.delete(`${baseUrl}/delete/${id}`);
  },
}
